import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Footer-Komponente für alle Seiten
 * @returns {JSX.Element} Footer
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 pt-6 pb-4 mt-auto">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col sm:flex-row justify-between items-center border-t border-gray-200 pt-4">
          <div className="mb-3 sm:mb-0">
            <Link to="/" className="flex items-center">
              <span className="text-base font-medium">
                <span className="text-blue-500">Sunny</span> Ride
              </span>
              <span className="ml-2">
                <span role="img" aria-label="bicycle" className="text-sm">🚲</span>
              </span>
            </Link>
          </div>
          
          <div className="flex items-center">
            <Link 
              to="/info" 
              className="text-sm text-gray-600 hover:text-blue-500 transition-colors duration-200"
            >
              <span className="mr-1">ℹ️</span> Projektinformationen
            </Link>
          </div>
          
          <div className="text-xs text-gray-500 mt-3 sm:mt-0">
            &copy; {currentYear} | Sunny Ride Project
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;